import React, { useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Box } from "@mui/material";
import PropTypes from "prop-types";
import { changePasswordCheckOldPwd } from "api/api_register2FA";
import Swal from "sweetalert2";
import SuiButton from "components/SuiButton";
import cancelIcon from "assets/images/cancelIcon.svg";
import TextFieldChangePass from "./FieldText";
import { useColorTheme } from "../../../../context/ColorThemeContext";

function ChangePassDialog({ open, setOpen, label }) {
  const colors = useColorTheme();
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const { username } = JSON.parse(localStorage.getItem("user"));
  const [error, setError] = useState("");
  const [passwordRules, setPasswordRules] = useState([
    { label: "Có ít nhất 8 ký tự", status: false },
    { label: "Có cả IN HOA và thường", status: false },
    { label: "Có ít nhất một số", status: false },
    { label: "Và một ký tự đặc biệt: !@#$%^&*", status: false },
  ]);
  const validatePassword = (password) => {
    const rulesCopy = [...passwordRules];
    rulesCopy[0].status = password.length >= 8;
    rulesCopy[1].status = /[a-z]/.test(password) && /[A-Z]/.test(password);
    rulesCopy[2].status = /\d/.test(password);
    rulesCopy[3].status = /[!@#$%^&*]/.test(password);

    setPasswordRules(rulesCopy);

    return rulesCopy.every((rule) => rule.status);
  };
  const changePassword = async () => {
    if (!validatePassword(newPassword)) {
      setError("Mật khẩu phải đủ 8 ký tự, IN HOA, thường, số và ký tự đặc biệt");
      return;
    }
    if (newPassword !== confirmPassword) {
      setError("Mật khẩu không khớp");
      return;
    }
    const data = await changePasswordCheckOldPwd(username, oldPassword, newPassword);
    if (data) {
      Swal.fire({
        title: "Đổi mật khẩu thành công",
        icon: "success",
        showConfirmButton: false,
        timer: 1500,
      });
      setError("");
      setOpen(false);
      return;
    }
    setError("Mật khẩu hiện tại không đúng");
  };
  return (
    <Dialog
      width="50%"
      open={open}
      sx={{
        "& .MuiDialog-paper": {
          width: "auto !important", // Đặt độ rộng là 40%
        },
        borderRadius: "15px !important",
        "& .MuiPaper-root": {
          borderRadius: "12px",
        },
      }}
    >
      <DialogTitle sx={{ margin: "-6px auto -12px auto", fontWeight: "bold", fontSize: 20 }}>
        {" "}
        Đổi mật khẩu
      </DialogTitle>
      <Box
        role="button"
        tabIndex="0"
        onKeyDown={() => {}}
        onClick={() => {
          setError("");
          setOpen(false);
        }}
        style={{
          position: "absolute",
          right: "12px",
          top: "6px",
          cursor: "pointer",
        }}
      >
        <img width={15} src={cancelIcon} alt="x" />
      </Box>
      <DialogContent sx={{ paddingBottom: 1 }}>
        {label.map((x) => (
          <TextFieldChangePass
            key={x}
            err={error}
            label={x}
            onChange={(e) => {
              if (x === "Mật khẩu hiện tại") {
                setOldPassword(e.target.value);
              }
              if (x === "Mật khẩu mới") {
                setNewPassword(e.target.value);
              } else {
                setConfirmPassword(e.target.value);
              }
            }}
          />
        ))}
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center" }}>
        <SuiButton
          color="transparent"
          sx={{
            border: "1px solid var(--blue-blue-100)",
            borderColor: colors.popupBackground || "var(--blue-blue-100) !important",
            width: "30%",
          }}
          onClick={() => {
            setError("");
            setOpen(false);
          }}
        >
          <Typography
            align="center"
            whiteSpace="nowrap"
            variant="body2"
            color={colors.popupBackground || "var(--blue-blue-100)"}
            fontSize="14px"
          >
            Hủy
          </Typography>
        </SuiButton>
        <SuiButton
          sx={{
            width: "30%",
          }}
          color={colors.popupBackground || "var(--blue-blue-100)"}
          onClick={changePassword}
        >
          <Typography
            style={{ margin: "0 auto", display: "flex" }}
            align="center"
            whiteSpace="nowrap"
            variant="body2"
            color={colors.popupText || "white"}
            fontSize="14px"
          >
            Đổi mật khẩu
          </Typography>
        </SuiButton>
      </DialogActions>
    </Dialog>
  );
}
ChangePassDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  // onClick: PropTypes.func.isRequired,
  setOpen: PropTypes.func.isRequired,
  label: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default ChangePassDialog;
